import React, { useState, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useField } from 'react-final-form';
import { FormBlockWrapper } from '../FormBlockWrapper';
import { DealTypeTabs } from '../../../DealTypeTabs';
import { CategoriesSelect } from '../../components/CategoriesSelect';
import { FORM_VALUES } from '../../../../../utils/helpers/constants';
import { SelectLocationMap } from '../../components/SelectLocationMap';
import { ContentWrapper } from './styled';
import { CitiesSelect } from '../../components/CitiesSelect';
import { RegionSelect } from '../../components/RegionSelect';
import { VillageSelect } from '../../components/VillageSelect';
import { FormTextInput } from '../../components/FormTextInput';
import { Coordinates } from '../../../../../providers/GoogleMapsProvider/types';
import { BlockInfo } from '../../components/BlockInfo';
import { CategoriesQuery } from '../../../../../graphql/graphql';

interface MainFormBlockProps {
  citiesLoading: boolean;
  setCitiesIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  categories?: CategoriesQuery['categories'] | null;
}

const ADDRESS_CHAR_LIMIT = '3000';

const tabsStats = [
  {
    value: 'false',
    dataStat: 'create_ad_step3_mode_sell'
  },
  {
    value: 'true',
    dataStat: 'create_ad_step3_mode_rent'
  }
];

const MainFormBlockComponent: React.FC<MainFormBlockProps> = ({
  citiesLoading,
  setCitiesIsLoading,
  categories
}) => {
  const { t } = useTranslation();
  const { input: locationIdField } = useField(FORM_VALUES.locationId, {
    subscription: { value: true }
  });
  const { input: cityHasLocationsField } = useField(
    FORM_VALUES.cityHasLocations,
    { subscription: { value: true } }
  );
  const [shouldRenderMap, setShouldRenderMap] = useState(false);
  const locationId = locationIdField.value;
  const cityHasLocations = cityHasLocationsField.value;

  const [initCoordinates, setInitCoordinates] = useState<Coordinates>();

  const isAddressShown = !citiesLoading && (!cityHasLocations || locationId);

  return (
    <FormBlockWrapper>
      <ContentWrapper data-cy="item-modal__type-deal">
        <DealTypeTabs dataStats={tabsStats} />
        <CategoriesSelect categories={categories} />
      </ContentWrapper>

      <CitiesSelect
        setCitiesLoading={setCitiesIsLoading}
        setInitCoordinates={setInitCoordinates}
        setShouldRenderMap={setShouldRenderMap}
      />

      {cityHasLocations && !citiesLoading && (
        <RegionSelect
          setInitCoordinates={setInitCoordinates}
          setShouldRenderMap={setShouldRenderMap}
        />
      )}

      {locationId && (
        <VillageSelect
          setInitCoordinates={setInitCoordinates}
          setShouldRenderMap={setShouldRenderMap}
        />
      )}

      {isAddressShown && (
        <>
          <FormTextInput
            name={FORM_VALUES.address}
            maxLength={ADDRESS_CHAR_LIMIT}
            placeholder={t('new_ad.address')}
            hasErrorField
          />
          <SelectLocationMap
            initialLocation={initCoordinates}
            shouldRenderMap={shouldRenderMap}
            setShouldRenderMap={setShouldRenderMap}
          />
          <BlockInfo
            text={t('new_ad.location_info')}
            cypress="create-item-location-block-info"
          />
        </>
      )}
    </FormBlockWrapper>
  );
};

export const MainFormBlock = memo(MainFormBlockComponent);
